import React, { useCallback, useRef, useState } from "react";

const BRUSH_SIZE_MIN = 8;
const BRUSH_SIZE_MAX = 100;

/**
 * Shared brush/eraser + mask state for AI remove tools.
 * `initialTool` is null when the screen should start with no tool selected.
 */
export function useAiMaskPaint(initialTool = "brush") {
  const [paintTool, setPaintTool] = useState(initialTool);
  const [brushSize, setBrushSize] = useState(28);
  const [brushSizeDraft, setBrushSizeDraft] = useState(null);
  const [hasMask, setHasMask] = useState(false);
  const [clearVersion, setClearVersion] = useState(0);
  const maskRef = useRef(null);

  const handleMaskChange = useCallback((next) => {
    setHasMask(Boolean(next));
  }, []);

  const clearMask = useCallback(() => {
    maskRef.current?.clear?.();
    setClearVersion((v) => v + 1);
    setHasMask(false);
  }, []);

  const brushSizePct =
    ((brushSize - BRUSH_SIZE_MIN) / (BRUSH_SIZE_MAX - BRUSH_SIZE_MIN)) * 100;
  const brushSliderBg = `linear-gradient(to right, #4f46e5 0%, #4f46e5 ${brushSizePct}%, #2a2a2a ${brushSizePct}%, #2a2a2a 100%)`;

  return {
    maskRef,
    paintTool,
    setPaintTool,
    brushSize,
    setBrushSize,
    brushSizeDraft,
    setBrushSizeDraft,
    brushSizeMin: BRUSH_SIZE_MIN,
    brushSizeMax: BRUSH_SIZE_MAX,
    brushSliderBg,
    hasMask,
    clearVersion,
    handleMaskChange,
    clearMask,
  };
}
